import { render, staticRenderFns } from "./LandingHeroSorteo.vue?vue&type=template&id=3ec805aa"
import script from "./LandingHeroSorteo.vue?vue&type=script&lang=js"
export * from "./LandingHeroSorteo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports